'use strict'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SearchContext from '../lib/react-storefront/search/SearchContext'
import useDebounce from '../hooks/useDebounce'
import { fetchLatest, StaleResponseError } from '../utils/fetchLatest'
import getAPIURL from '../lib/react-storefront/api/getAPIURL'

const fetchWithLatest = fetchLatest((url, opts) => globalThis.fetch(url, opts))

function SearchProvider({
  children,
  query,
  initialGroups,
  active,
  minQueryLength = 3,
  debounceTime = 250,
  store: storeSlug,
}) {
  const [state, setState] = useState({
    groups: initialGroups,
    loading: true,
  })

  const debouncedQuery = useDebounce(query, debounceTime)

  const fetchSuggestions = async (text) => {
    try {
      setState(prev => ({ ...prev, loading: true }))

      const url = getAPIURL(`/store/${storeSlug}/suggestions?q=${encodeURIComponent(text.trim())}`)
      const { groups } = await fetchWithLatest(url, { credentials: 'include' }).then(res => res.json())

      setState(prev => ({
        ...prev,
        loading: false,
        groups,
      }))
    } catch (error) {
      if (!StaleResponseError.is(error)) {
        setState(prev => ({ ...prev, loading: false }))
      }
    }
  }

  useEffect(() => {
    if (active && (debouncedQuery.length >= minQueryLength || !debouncedQuery)) {
      fetchSuggestions(debouncedQuery)
    }
  }, [active, debouncedQuery])
  useEffect(() => {
    fetchSuggestions(debouncedQuery)
  }, [storeSlug])

  const context = {
    query: debouncedQuery,
    state,
    setState,
    fetchSuggestions,
  }
  return (
    <SearchContext.Provider value={context}>
      {children}
    </SearchContext.Provider>
  )
}

SearchProvider.propTypes = {
  children: PropTypes.node,
  query: PropTypes.string,
  initialGroups: PropTypes.array,
  active: PropTypes.bool,
  minQueryLength: PropTypes.number,
  debounceTime: PropTypes.number,
  store: PropTypes.string.isRequired,
}
export default SearchProvider
